import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "../../constants/Routes";
import { UserFilter, UserFilterOptions } from "../../models/UserFilterOptions";
import { IsUserInternal } from "../../services/AuthService";
import { FilterController } from "../sharedControllers/FilterController";

/**
 * @namespace akademika.akamont.pages.userList
 */

export default class UserList extends FilterController {
  route = Routes.USER_LIST;
  parentRoute = Routes.DASHBOARD;

  onInit() {
    super.onInit();
    const defaultFilter: UserFilter = {
      email: undefined,
      partnerId: undefined,
    };
    this.initFilters(defaultFilter, "api/User/GetUserList");
  }

  public async onRouteMatched() {
    this.setModel(new JSONModel({ value: IsUserInternal() }), "isUserInternal");
    this.getFilterOptions();
  }

  private async getFilterOptions() {
    await this.fetchModel<UserFilterOptions>(
      "api/User/GetUserFilterOptions",
      "filterOptions"
    );
  }

  public async onUserDetails(id: string) {
    this.navTo(Routes.USER_DETAILS, { id: id });
  }

  public async onNewUser() {
    this.navTo(Routes.USER_ADD);
  }
}
